import { seoDataType } from '../types/seoSchema';

export const seoMockData: seoDataType = {
  h1: 'Летние шины в Москве',
  title: 'Летние шины в Москве от 2630 руб - купить в интернет магазине',
  metaTags: [
    { name: 'keywords', content: 'летние шины, купить  летние шины,  летние шины недорого,  летние шины в москве' },
    {
      name: 'description',
      content:
        '&#10004; Купить  летние шины в Москве от 2630 руб, характеристики, наличие в магазинах Колесо.ру. &#128666; Бесплатная доставка  летние шин по России.',
    },
  ],
  breadcrumb: [
    { title: 'Шины', href: '/catalog/tyres/' },
    { title: 'Летние шины', href: '' },
  ],
  blocks: [
    {
      idBlock: '',
      title: 'Диаметры',
      links: [
        {
          title: 'R15',
          href: '/',
        },
        {
          title: 'R16',
          href: '/',
        },
        {
          title: 'R17',
          href: '/',
        },
        {
          title: 'R18',
          href: '/',
        },
        {
          title: 'R19',
          href: '/',
        },
      ],
    },
  ],
  annotation: [
    '<div class="jumbotron" style="font-size: 14px;"><h2>Шины Ikon Tyres</h2>\n' +
      'Ikon Tyres — это молодой российский бренд автомобильных шин, созданный для замещения продукции финской марки Nokian. Специалисты нового предприятия имеют опыт производства с 2005 года, который позволяет им поддерживать качество продукции на стабильно высоком премиальном уровне. Независимо от сезонности, все шины Айкон оптимизированы для эксплуатации в сложном климате северных регионов. В ассортименте представлена резина для:\n' +
      '<ul>\n' +
      '  <li>Легковых авто;</li>\n' +
      '  <li>Кроссоверов;</li>\n' +
      '  <li>Пикапов;</li>\n' +
      '  <li>Внедорожников;</li>\n' +
      '  <li>Коммерческого транспорта.</li>\n' +
      '</ul>\n' +
      'На сайте Колесо.ру вы можете подобрать и приобрести оптимальную для собственных потребностей и предпочтений летнюю или зимнюю резину Ikon. Большинство из них являются адаптированными аналогами флагманских моделей Nokian. Значительная часть продукции участвует в расширенной гарантийной программе Айкон и акции «Бесплатный шиномонтаж».\n' +
      '<h3>Преимущества шин Ikon Tyres</h3>\n' +
      '<ul>\n' +
      '  <li><em>Широкий ассортимент.</em> Под маркой Айкон выпускаются модели в самых разных ценовых категориях, однако все они обеспечивают высокую безопасность и комфорт движения на российских дорогах.</li>\n' +
      '  <li><em>Технологичность.</em> Производственное предприятие в Ленинградской области оснащено современным комплексом оборудования, позволяющим поддерживать качество продукции на стабильно высоком уровне.</li>\n' +
      '  <li><em>Предпродажные тесты.</em> Перед выпуском в серийное производство каждая партия шин Ikon проходит многочисленные испытания в лабораторных и полевых условиях, подтверждающие соответствие заявленным характеристикам.</li>\n' +
      '  <li><em>Забота об экологии.</em> Модели Айкон производят из экологически безопасных материалов, а стабильно высокие показатели лёгкости качения позволяют сократить уровень выбросов вредных веществ в окружающую среду.</li>\n' +
      '</ul>\n' +
      '<h4>О бренде Ikon Tyres</h4>\n' +
      'Компания Ikon была организована в 2023 году на базе масштабного шинного завода в городе Всеволожск Ленинградской области. Потенциальная производственная мощность предприятия составляет 17 млн шин для легковых, SUV и коммерческих автомобилей. Наличие собственного отдела R&amp;D позволяет компании разрабатывать новые модели с использованием передовых технологий, а также адаптировать существующую продукцию к российским условиям.</div>\n' +
      '\n',
    `
    <p>&#10004; Шины R#size#  в #regione# - от #price# руб., характеристики, отзывы, наличие в магазинах Колесо.ру</p>

<p>&#10004; В разделе шины R#size# интернет магазина КОЛЕСО представлен широкий ассортимент товаров по выгодным ценам.</p>

<p>&#10004; В большом каталоге шин вы можете посмотреть фото, изучить цены, рейтинг, прочитать отзывы покупателей, что поможет быстро выбрать и купить шины  R#size# от #price# руб.</p>

<p>&#10004; Найдено #count# шин размеров R#size# в наличии в интернет магазине.</p>

    `,
  ],
};

export const seoMockDataAuto: seoDataType = {
  h1: 'Подбор шин по авто в Москве',
  title: 'Подбор шин по авто в Москве',
  metaTags: [
    { name: 'keywords', content: 'Подбор шин по авто, Подбор шин по машине' },
    { name: 'description', content: 'Подбор шин по авто по типоразмерам, сезонности. Шины на вашу машину недорого, с доставкой по РФ' },
  ],
  breadcrumb: [
    { title: 'Главная', href: '/' },
    { title: 'Подбор шин и дисков по автомобилю', href: '/auto/' },
    { title: 'MERCEDES', href: '/auto/mercedes/' },
    { title: 'CLK-Klasse', href: '/auto/mercedes/c-klasse/' },
  ],
  blocks: [
    {
      idBlock: '',
      title: 'Диаметры',
      links: [
        {
          title: 'R15',
          href: '/',
        },
        {
          title: 'R16',
          href: '/',
        },
        {
          title: 'R17',
          href: '/',
        },
        {
          title: 'R18',
          href: '/',
        },
        {
          title: 'R19',
          href: '/',
        },
      ],
    },
    {
      idBlock: 'link-winter-block',
      title: 'Зимние шины',
      links: [
        {
          title: 'R15',
          href: '/',
        },
        {
          title: 'R16',
          href: '/',
        },
        {
          title: 'R17',
          href: '/',
        },
        {
          title: 'R18',
          href: '/',
        },
        {
          title: 'R19',
          href: '/',
        },
        {
          title: '195/55/55',
          href: '/',
        },
        {
          title: '195/65/65',
          href: '/',
        },
        {
          title: '205/60/60',
          href: '/',
        },
        {
          title: '215/45/45',
          href: '/',
        },
        {
          title: '225/45/45',
          href: '/',
        },
        {
          title: '225/50/50',
          href: '/',
        },
        {
          title: '235/35/35',
          href: '/',
        },
        {
          title: '245/40/40',
          href: '/',
        },
        {
          title: '265/30/30',
          href: '/',
        },
        {
          title: '285/30/30',
          href: '/',
        },
      ],
    },
    {
      idBlock: 'link-summer-block',
      title: 'Летние шины',
      links: [
        {
          title: 'R15',
          href: '/',
        },
        {
          title: 'R16',
          href: '/',
        },
        {
          title: 'R17',
          href: '/',
        },
        {
          title: 'R18',
          href: '/',
        },
        {
          title: 'R19',
          href: '/',
        },
        {
          title: '195/55/55',
          href: '/',
        },
        {
          title: '195/65/65',
          href: '/',
        },
        {
          title: '205/60/60',
          href: '/',
        },
        {
          title: '215/45/45',
          href: '/',
        },
        {
          title: '225/45/45',
          href: '/',
        },
        {
          title: '225/50/50',
          href: '/',
        },
        {
          title: '235/35/35',
          href: '/',
        },
        {
          title: '245/40/40',
          href: '/',
        },
        {
          title: '265/30/30',
          href: '/',
        },
        {
          title: '285/30/30',
          href: '/',
        },
        {
          title: '195/65/65',
          href: '/',
        },
        {
          title: '205/60/60',
          href: '/',
        },
        {
          title: '215/45/45',
          href: '/',
        },
        {
          title: '225/45/45',
          href: '/',
        },
        {
          title: '225/50/50',
          href: '/',
        },
        {
          title: '235/35/35',
          href: '/',
        },
        {
          title: '245/40/40',
          href: '/',
        },
        {
          title: '265/30/30',
          href: '/',
        },
        {
          title: '285/30/30',
          href: '/',
        },
        {
          title: '215/45/45',
          href: '/',
        },
        {
          title: '225/45/45',
          href: '/',
        },
        {
          title: '225/50/50',
          href: '/',
        },
        {
          title: '235/35/35',
          href: '/',
        },
        {
          title: '245/40/40',
          href: '/',
        },
        {
          title: '265/30/30',
          href: '/',
        },
        {
          title: '285/30/30',
          href: '/',
        },
      ],
    },
  ],
};
